import FinTronConfig from '@fintronners/react-config/src/Config/FinTronConfig';

export const isBradesco = FinTronConfig.tenant === 'bradesco';

export const taxIdMasks = {
  US: '[000]-[00]-[0000]',
  BR: '[000].[000].[000]-[00]',
} as const;

export const getTaxIdMask = (): string => {
  if (isBradesco) {
    return taxIdMasks.BR;
  }

  return taxIdMasks.US;
};

export const isBradescoTenant = (): boolean => {
  return isBradesco;
};

export const getTenantSpecificConfig = () => {
  return {
    isBradesco: isBradescoTenant(),
    taxIdMask: getTaxIdMask(),
  };
};
